import GeneralPreview from "./GeneralPreview";
export default GeneralPreview;